import worldSVG from '@plone/volto/icons/world.svg';

import { MapLibreView, MapLibreEdit } from './MapLibre';

// export default (config) => {
//  ... update
//  return config;
// };

const applyConfig = (config) => {
  config.blocks.blocksConfig.mapLibre = {
    id: 'mapLibre',
    title: 'Map Libre',
    icon: worldSVG,
    group: 'common',
    view: MapLibreView,
    edit: MapLibreEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
